import React from 'react';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import './cklaBlock.scss';
import CKLATable from '../cklaTable/cklaTable';

const CKLABlock = ({ widgetData }) =>
    !isEmpty(widgetData) && (
        <section className="ckla-block">
            <div className="ckla-block-header-banner" />
            <div className="ckla-block-header">
                <h2 className="ckla-header-title">CKLA Connect</h2>
                <p className="ckla-header-description">
                    Find lessons from your CKLA core instruction to support students in this group.
                </p>
            </div>
            <CKLATable widgetData={widgetData} />
        </section>
    );

CKLABlock.defaultProps = {
    widgetData: [],
};

CKLABlock.propTypes = {
    widgetData: PropTypes.array,
};

export default CKLABlock;
